import { getEndpoint } from "@api-routes/endpoint";

const EIR_STANCER_FACADE_MS_NAME = "eir-stancer-facade";

export const getOneOffPaymentHppApiRoute = (amount?: number) =>
    `${getEndpoint(EIR_STANCER_FACADE_MS_NAME)}hpp/payments${amount ? `?amount=${amount}` : ""}`;

export const payWithSavedCardOnceOffPaymentApiRoute = (cardId: string) =>
    `${getEndpoint(EIR_STANCER_FACADE_MS_NAME)}payments/cards/${cardId}`;

export const CARDS_HPP_API_ROUTE = `${getEndpoint(EIR_STANCER_FACADE_MS_NAME)}hpp/cards`;
